module.exports = __webpack_public_path__ + "static/media/potter.ad1579f4.png";